import { setCookie, removeCookie, getCookie } from '../../../assets/scripts/utils/cookies';
let cookieBar;
let userVersionCookies;
let cookieBannerPostUrl = '';
let theme = "default";

const ACTIVE = 'active';
const READY = 'ready';
const CLOSING = 'closing';
const tracker = typeof _mtm !== 'undefined' ? _mtm : typeof dataLayer !== 'undefined' ? dataLayer : false;

if (!tracker) console.warn("No Tag-Manager script found!");

function initCookieBanner() {
    window.cookiesDecision = [];

    cookieBar = document.getElementById('cookie-bar');
    userVersionCookies = getCookie('cookiebanner.version');

    if (cookieBar && cookieBar.classList.contains('theme--modal')) {
        theme = "modal";
    }

    if (cookieBar) {
        if (typeof getCookie('session-id') === 'undefined') {
            setCookie('session-id', Date.now().toString() + parseInt(Math.random() * 10000));
        }

        let cookieBannerVersion = cookieBar.dataset.version;

        let cookieBannerExcludedUrls = [];
        let cookieBannerPageIsExcluded = false;

        if (cookieBar.dataset.excludedUrls) {
            cookieBannerExcludedUrls = cookieBar.dataset.excludedUrls.split(',');
        }

        for (let i = 0; i < cookieBannerExcludedUrls.length; i++) {
            if (window.location.href.indexOf(cookieBannerExcludedUrls[i]) > -1) {
                cookieBannerPageIsExcluded = true;
            }
        }

        if (cookieBar.dataset.postUrl) {
            cookieBannerPostUrl = cookieBar.dataset.postUrl;
        }

        let cookiePreference = cookieBar.getElementsByClassName('cookie-bar__preference')[0];
        let cookieSettings = cookieBar.getElementsByClassName('cookie-bar__settings')[0];
        let cookieNavigator = cookieBar.getElementsByClassName('cookie-bar--navigator');

        let cookieInformationTriggers = cookieBar.getElementsByClassName('cookie-bar__item--trigger');
        let buttonAcceptCookies = cookieBar.getElementsByClassName('btn-cookie-accept');

        let acceptSwitches = cookieBar.getElementsByClassName('cookie-accept');
        let acceptAllCookies = cookieBar.getElementsByClassName('cookie-accept-all');

        let checkboxAcceptGroup = cookieBar.getElementsByClassName('cookie-accept-group');

        // external links to open cookie-bar
        let openCookieBarLinks = document.body.getElementsByClassName('cookie-preference');
        if (openCookieBarLinks) {
            handleOpenCookieBarLinks(openCookieBarLinks, cookieBar);
        }

        // external switches to accept or decline single cookies
        let singleCookieSwitches = document.body.getElementsByClassName('cookie-decision');
        if (singleCookieSwitches) {
            handleSingleCookieSwitches(singleCookieSwitches, acceptAllCookies);
        }

        // embed containers
        let embedContainers = document.getElementsByClassName('cb-embed');

        handleSingleCookies(acceptSwitches, acceptAllCookies);

        handleCookieSettingsSwitch(cookieNavigator, cookiePreference, cookieSettings, theme);

        handleInitialCookies(acceptSwitches, acceptAllCookies, checkboxAcceptGroup, embedContainers);

        handleAcceptCookiesButton(buttonAcceptCookies, acceptSwitches, acceptAllCookies, checkboxAcceptGroup, singleCookieSwitches, cookieBannerVersion);

        handleGroupTrigger(acceptAllCookies, checkboxAcceptGroup);

        handleCookieInformationTriggers(cookieInformationTriggers);

        if (!cookieBannerPageIsExcluded && !document.body.classList.contains('cookie-bar-hidden') && (userVersionCookies !== cookieBannerVersion)) {
            document.body.classList.add('cookie-overlay');
            cookieBar.classList.add(ACTIVE);
            cookieBar.setAttribute('aria-hidden', 'false');
            handleInitialCheckBoxes(acceptAllCookies, acceptSwitches, checkboxAcceptGroup);
            activateTabIndexes();
        }
    }
}

window.addEventListener('load', initCookieBanner);

function activateTabIndexes() {
    let tabbableElements = cookieBar.querySelectorAll('[data-tabindex]');
    for (let i = 0; i < tabbableElements.length; i++) {
        tabbableElements[i].setAttribute('tabindex', tabbableElements[i].dataset.tabindex);
    }
}

function deactivateTabIndexes() {
    let tabbableElements = cookieBar.querySelectorAll('[data-tabindex]');
    for (let i = 0; i < tabbableElements.length; i++) {
        tabbableElements[i].setAttribute('tabindex', '-1');
    }
}

function handleInitialCheckBoxes(acceptAllCookies, acceptSwitches, checkboxAcceptGroup) {
    for (let i = 0; i < acceptAllCookies.length; i++) {
        acceptAllCookies[i].checked = false;
    }

    for (let a = 0; a < acceptSwitches.length; a++) {
        acceptSwitches[a].checked = false;
    }

    for (let j = 0; j < checkboxAcceptGroup.length; j++) {
        checkboxAcceptGroup[j].getElementsByTagName('input')[0].checked = false;
    }
}

function handleOpenCookieBarLinks(openCookieBarLinks) {
    for (let i = 0; i < openCookieBarLinks.length; i++) {
        openCookieBarLinks[i].addEventListener('click', function (e) {
            e.preventDefault();
            document.body.classList.add('cookie-overlay');
            cookieBar.classList.add(ACTIVE);
            cookieBar.setAttribute('aria-hidden', 'false');
            activateTabIndexes();
        });
    }
}

function handleSingleCookieSwitches(singleCookieSwitches) {
    for (let i = 0; i < singleCookieSwitches.length; i++) {
        let currentValue = singleCookieSwitches[i].value;
        let acceptedCookies = getCookie('cookiebanner.services.accepted');
        if (acceptedCookies) {
            acceptedCookies = acceptedCookies.split(',');
            if (acceptedCookies.indexOf(currentValue) > -1) {
                singleCookieSwitches[i].checked = true;
            }
        } else {
            singleCookieSwitches[i].checked = false;
        }
        singleCookieSwitches[i].addEventListener('click', function () {
            let acceptedCookies = getCookie('cookiebanner.services.accepted');
            if (acceptedCookies) {
                let acceptedCookiesArray = acceptedCookies.split(',');
                let positionInArray = acceptedCookies.split(',').indexOf(singleCookieSwitches[i].value);
                if (positionInArray > -1) {
                    if (!singleCookieSwitches[i].checked) {
                        let filtered = acceptedCookiesArray.filter(function (value) {
                            return singleCookieSwitches[i].value !== value;
                        });
                        if (filtered.length > 0) {
                            setCookie('cookiebanner.services.accepted', filtered.join(','), 365);
                        } else {
                            removeCookie('cookiebanner.services.accepted');
                        }
                    }
                } else {
                    if (singleCookieSwitches[i].checked) {
                        acceptedCookiesArray.push(singleCookieSwitches[i].value);
                        setCookie('cookiebanner.services.accepted', acceptedCookiesArray.join(','), 365);
                    }
                }
            } else {
                setCookie('cookiebanner.services.accepted', singleCookieSwitches[i].value, 365);
            }

            setTimeout(function () {
                location.reload();
            }, 400);
        });
    }
}

function handleSlideDown(openElement, closedElement, timeOut) {
    if (theme === 'modal') {
        openElement.classList.add(CLOSING);
        setTimeout(function() {
            openElement.classList.remove(READY, ACTIVE, CLOSING);
            closedElement.classList.add(CLOSING);
            setTimeout(function() {
                if (!openElement.parentElement.classList.contains(READY)) {
                    openElement.parentElement.classList.add(READY);
                } else {
                    openElement.parentElement.classList.remove(READY);
                }
                setTimeout(function() {
                    closedElement.classList.add(ACTIVE);
                    closedElement.classList.remove(CLOSING);
                    setTimeout(function() {
                        closedElement.classList.add(READY);
                    }, timeOut);
                }, timeOut);
            }, timeOut);
        }, timeOut);
    } else {
        openElement.classList.remove(READY);
        openElement.style.height = '';
        setTimeout(function () {
            openElement.classList.remove(ACTIVE);
            closedElement.style.height = closedElement.scrollHeight + 'px';
            closedElement.classList.add(ACTIVE);
            setTimeout(function () {
                closedElement.classList.add(READY);
            }, timeOut);
        }, timeOut);
    }
}

function handleCookieSettingsSwitch(cookieNavigator, cookiePreference, cookieSettings, theme) {
    let timeOut = (theme === 'modal') ? 250 : 500;

    if (theme !== 'modal') {
        handleSlideDown(cookieSettings, cookiePreference, timeOut);
    }

    for (let i = 0; i < cookieNavigator.length; i++) {
        cookieNavigator[i].addEventListener('click', function (event) {
            event.preventDefault();
            if (event.target.classList.contains('cookie-bar__settings--trigger')) { // custom settings
                handleSlideDown(cookiePreference, cookieSettings, timeOut);
            } else { // back button
                handleSlideDown(cookieSettings, cookiePreference, timeOut);
            }
        });
    }
}

function handleInitialCookies(acceptElements, acceptAllElements, acceptAllGroups, embedContainers) {
    let acceptedCookies = getCookie('cookiebanner.services.accepted');
    if (acceptedCookies) {
        let statistics = false;
        let additional = false;
        acceptedCookies = acceptedCookies.split(',');
        for (let i = 0; i < acceptElements.length; i++) {
            if (acceptedCookies.indexOf(acceptElements[i].value) > -1) {
                if (acceptElements[i].classList.contains('controlled-by-statistics')) {
                    statistics = true;
                }
                if (acceptElements[i].classList.contains('controlled-by-other')) {
                    additional = true;
                }
                acceptElements[i].checked = true;
                window.cookiesDecision.push(acceptElements[i].value);
            }
        }

        if (acceptedCookies.length > 0) {
            for (let b = 0; b < acceptAllElements.length; b++) {
                if (acceptAllElements[b].classList.contains('cookie-accept-all-statistics') && statistics ||
                    acceptAllElements[b].classList.contains('cookie-accept-all-other') && additional) {
                    acceptAllElements[b].checked = true;
                }
            }

            for (let c = 0; c < acceptAllGroups.length; c++) {
                if (acceptAllGroups[c].getElementsByTagName('input')[0].id === "statistics" && statistics ||
                    acceptAllGroups[c].getElementsByTagName('input')[0].id === "other" && additional) {
                    acceptAllGroups[c].getElementsByTagName('input')[0].checked = true;
                }
            }
        }
    }
    handleEmbed(acceptedCookies, embedContainers);
}

function handleEmbed(services, embedContainers) {
    let includedServices = [];

    for (let x = 0; x < embedContainers.length; x++) {
        let service = embedContainers[x].dataset.cbService;
        let placeholder = embedContainers[x].getElementsByClassName('cb-embed__placeholder')[0];
        let acceptButton = placeholder.getElementsByClassName('cb-embed__button')[0];

        if (!includedServices.includes(service)) {
            includedServices.push(service);
        }

        acceptButton.addEventListener('click', function () {
            let acceptedCookies = getCookie('cookiebanner.services.accepted');
            if (!acceptedCookies.split(',').includes(service)) {
                let newServices = [];
                if (acceptedCookies.length) {
                    newServices = acceptedCookies.split(',');
                }
                newServices.push(service);
                setCookie('cookiebanner.services.accepted', newServices.join(','), 365);
                handleEmbedActivation(embedContainers, service);
            }
        });

        if ((x + 1) === embedContainers.length && services.includes(service)) {
            handleEmbedActivation(embedContainers, service);
        }
    }
}

function handleEmbedActivation(items, service) {
    let scriptsToLoad = [];
    let functionsToExecute = [];

    for (let i = 0; i < items.length; i++) {
        if (items[i].dataset.cbService === service) {
            let sources = items[i].dataset.cbSources.split(',')
            let iFrames = items[i].getElementsByClassName('cb-embed__iframe');

            items[i].getElementsByClassName('cb-embed__placeholder')[0].remove();
            functionsToExecute.push(items[i].dataset.cbFunction);

            for (let j = 0; j < sources.length; j++) {
                if (!scriptsToLoad.includes(sources[j])) {
                    scriptsToLoad.push(sources[j]);
                }
            }

            for (let j = 0; j < iFrames.length; j++) {
                iFrames[j].src = iFrames[j].dataset.cbIframe;
            }
        }

        if ((i + 1) === items.length) {
            for (let s = 0; s < scriptsToLoad.length; s++) {
                let scriptTag = document.createElement('script');
                scriptTag.type = 'text/javascript';
                scriptTag.src = scriptsToLoad[s];
                document.body.appendChild(scriptTag);

                if ((s + 1) === scriptsToLoad.length) {
                    scriptTag.onload = function () {
                        for (let j = 0; j < functionsToExecute.length; j++) {
                            if (typeof cbLoadScripts !== 'undefined') {
                                cbLoadScripts[functionsToExecute[j]]();
                            }
                        }
                    }
                }
            }
        }
    }
}

function handleAcceptCookiesButton(buttonAcceptCookies, acceptElements, acceptAllElements, acceptAllGroups, singleCookieSwitches, cookieBannerVersion) {
    if (buttonAcceptCookies.length > 0) {
        for (let i = 0; i < buttonAcceptCookies.length; i++) {
            buttonAcceptCookies[i].addEventListener('click', function (event) {
                let activatedCookies = [];
                if (event.target.classList.contains('btn-cookie-accept-all')) {
                    for (let a = 0; a < acceptElements.length; a++) {
                        acceptElements[a].checked = true;
                        let isSaved = window.cookiesDecision.indexOf(acceptElements[a].value);
                        if (isSaved === -1) {
                            window.cookiesDecision.push(acceptElements[a].value);
                        }
                        activatedCookies.push(acceptElements[a].value);
                        if (tracker) {
                            tracker.push({event: 'cookiebanner.' + [acceptElements[a].value] + '.activate'});
                        }
                    }

                    setCookie('cookiebanner.services.accepted', activatedCookies.join(','), 365);

                    for (let b = 0; b < acceptAllElements.length; b++) {
                        acceptAllElements[b].checked = true;
                    }
                    for (let c = 0; c < acceptAllGroups.length; c++) {
                        acceptAllGroups[c].getElementsByTagName('input')[0].checked = true;
                    }
                } else {
                    window.cookiesDecision = [];
                    for (let a = 0; a < acceptElements.length; a++) {
                        if (acceptElements[a].checked) {
                            activatedCookies.push(acceptElements[a].value);
                            if (tracker) {
                                tracker.push({event: 'cookiebanner.' + [acceptElements[a].value] + '.activate'});
                            }
                        } else {
                            if (tracker) {
                                tracker.push({event: 'cookiebanner.' + [acceptElements[a].value] + '.deactivate'});
                            }
                        }
                    }
                    if (activatedCookies.length) {
                        setCookie('cookiebanner.services.accepted', activatedCookies.join(','), 365);
                    } else {
                        removeCookie('cookiebanner.services.accepted');
                    }
                }
                if (cookieBannerPostUrl) {
                    postCookieBannerData(activatedCookies);
                }
                setCookie('cookiebanner.version', cookieBannerVersion, 365);

                cookieBar.classList.add('flipOutX');

                setTimeout(function () {
                    document.body.classList.remove('cookie-overlay');
                    cookieBar.classList.remove(ACTIVE);
                    cookieBar.setAttribute('aria-hidden', 'true');
                    cookieBar.classList.remove('flipOutX');
                    handleSingleCookieSwitches(singleCookieSwitches);
                    deactivateTabIndexes();
                }, 500);
            });
        }
    }
}

function postCookieBannerData(services) {
    let d = new Date();
    let year = d.getFullYear();
    let month = ('0' + (d.getMonth() + 1)).slice(-2);
    let day = ('0' + d.getDate()).slice(-2);
    let date = day + '.' + month + '.' + year;
    let hours = ('0' + d.getHours()).slice(-2);
    let minutes = ('0' + d.getMinutes()).slice(-2);
    let time = hours + ':' + minutes;
    let url = location.href;

    let cookieData = {
        "date": [date],
        "time": [time],
        "services": services,
        "url": [url]
    };

    //let cookieBannerPostUrl = "https://reqbin.com/echo/post/json";
    let xhr = new XMLHttpRequest();
    xhr.open("POST", cookieBannerPostUrl);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(cookieData));
}

function handleGroupTrigger(acceptAllElements, checkboxAcceptGroup) {
    if (acceptAllElements.length > 0) {
        for (let i = 0; i < acceptAllElements.length; i++) {
            acceptAllElements[i].addEventListener('change', function (event) {
                let acceptElements = cookieBar.getElementsByClassName('controlled-by-' + event.target.dataset.controls);
                for (let a = 0; a < checkboxAcceptGroup.length; a++) {
                    let input = checkboxAcceptGroup[a].getElementsByTagName('input')[0];
                    if (input.id === event.target.value) {
                        input.checked = event.target.checked;
                    }
                }
                for (let b = 0; b < acceptElements.length; b++) {
                    acceptElements[b].checked = event.target.checked;
                    if (event.target.checked && window.cookiesDecision.indexOf(acceptElements[b].value) === -1) {
                        window.cookiesDecision.push(acceptElements[b].value);
                    }
                }
                if (!event.target.checked) {
                    window.cookiesDecision = [];
                }
            });
        }
    }

    if (checkboxAcceptGroup.length > 0) {
        for (let i = 0; i < checkboxAcceptGroup.length; i++) {
            checkboxAcceptGroup[i].addEventListener('change', function () {
                let input = this.getElementsByTagName('input')[0];
                for (let a = 0; a < acceptAllElements.length; a++) {
                    if (acceptAllElements[a].value === input.id) {
                        acceptAllElements[a].click();
                    }
                }
            });
        }
    }
}

function handleSingleCookies(acceptElements) {
    if (acceptElements.length > 0) {
        for (let i = 0; i < acceptElements.length; i++) {
            acceptElements[i].addEventListener('change', function (event) {
                let isSaved = window.cookiesDecision.indexOf(event.target.value);
                let parentSwitch = document.getElementById("switch-" + event.target.dataset.controller);
                let groupCheckbox = document.getElementById(event.target.dataset.controller);

                if (event.target.checked) {
                    window.cookiesDecision.push(event.target.value);
                } else {
                    if (isSaved !== -1) {
                        window.cookiesDecision.splice(isSaved, 1);
                    }
                    parentSwitch.checked = false;
                }
                let specificAcceptElements = cookieBar.getElementsByClassName('controlled-by-' + event.target.dataset.controller);
                let checked = false;

                for (let i = 0; i < specificAcceptElements.length; i++) {
                    if (specificAcceptElements[i].checked) {
                        checked = true;
                    }
                }

                if (checked) {
                    parentSwitch.checked = true;
                    groupCheckbox.checked = true;
                } else {
                    parentSwitch.checked = false;
                    groupCheckbox.checked = false;
                }
            });
        }
    }
}

function handleCookieInformationTriggers(cookieInformationTriggers) {
    if (cookieInformationTriggers.length > 0) {
        for (let i = 0; i < cookieInformationTriggers.length; i++) {
            cookieInformationTriggers[i].addEventListener('click', function (e) {
                e.preventDefault();
                if (!this.classList.contains(ACTIVE)) {
                    for (let a = 0; a < cookieInformationTriggers.length; a++) {
                        if (
                            cookieInformationTriggers[a].classList.contains(ACTIVE)
                        ) {
                            cookieInformationTriggers[a].classList.remove(ACTIVE);
                        }
                    }
                }
                this.classList.toggle(ACTIVE);
            });
        }
    }
}

